import React from 'react';
import { TextField, InputAdornment, FormControl, Select, MenuItem, Tooltip } from '@mui/material';
import theme from '../../themes/index.en';
import { CustomTextAreaProps } from './customTextAreaProps';

const CustomTextArea: React.FC<CustomTextAreaProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  required,
  error,
  helperText,
  disabled,
  readOnly
}) => {
  const customLabel = (
    <>
      <Tooltip title={label} placement="top" arrow>
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          {label}
          {required && <span style={{ marginLeft: '5px', color: theme.palette.error.main }}>*</span>}
        </span>
      </Tooltip>
    </>
  );

  return (
    <FormControl fullWidth margin="normal">
      <TextField
        id={name}
        label={customLabel}
        name={name}
        multiline
        rows={4}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error || false}
        helperText={helperText || ""}
        disabled={disabled}
        InputLabelProps={{
          shrink: true,
        }}
        FormHelperTextProps={{ style: { color: theme.palette.error.main } }}
        InputProps={{
          readOnly: readOnly, 
          style: { 
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.default,
            ...(disabled && { color: theme.palette.action.disabled }),
          },
        }}
        fullWidth
      />
    </FormControl>
  );
};

export default CustomTextArea;
